<template>
  <div>
    <!-- <v-skeleton-loader class="mx-auto ml-2 mr-2" type="card" :loading="loading">
      <CommunityInfo
        :communityInfo="communityInfo"
        @onRelatedCommunityChanged="showRelatedCommunity"
      />
    </v-skeleton-loader> -->
    <div class="general-info d-flex flex-wrap justify-space-between py-4">
      <div class="general-info-item d-flex flex-wrap d-md-inline">
        <div class="w-auto d-flex align-items-center px-2">
          <span class="symbol symbol-50 symbol-light-success mx-3">
            <a :href="`mailto:${accountManagerEmail}`">
              <img
                alt="email"
                src="/media/assets/icons/icons_email.png"
                style="width: 50px"
              />
            </a>
          </span>
          <div class="d-md-inline align-self-center comunity-info-manager">
            <span
              class="text-black font-weight-bolder font-size-h4 d-md-inline"
            >
              Landscape Point of Contact:
            </span>
            <div class="text-black font-size-h5">
              {{ accountManagerName }}
            </div>
            <div class="text-black font-size-h5" v-if="!isValenciaResident">
              {{ accountManagerPhone }}
            </div>
            <!-- <h6 class="font-weight-bold">
              Managed by:
            </h6>
            <div>{{ communityInfoManagementCompanyName }}</div>
            <div>
              {{ communityInfoManagementCompanyAddressLine1 }}
            </div>
            <div
              v-if="
                communityInfoManagementCompanyAddressCity ||
                  communityInfoManagementCompanyAddressStateCode ||
                  communityInfoManagementCompanyAddressPostalCode
              "
            >
              {{ communityInfoManagementCompanyAddressCity }},
              {{ communityInfoManagementCompanyAddressStateCode }}
              {{ communityInfoManagementCompanyAddressPostalCode }}
            </div>
            <div v-if="communityInfoManagementCompanyAddressPhone">
              {{ communityInfoManagementCompanyAddressPhone }}
            </div> -->
          </div>
        </div>
        <div
          class="w-auto d-flex align-items-center px-2 mt-3"
          v-if="
            !isValenciaResident &&
              permissions &&
              permissions.documents &&
              permissions.documents.canView
          "
        >
          <span class="symbol symbol-auto symbol-light-success mx-3">
            <router-link :to="`/customerView/${customerId}/documents`">
              <img
                alt="Landscape documents"
                src="/media/assets/icons/icons_landscape_docs.png"
                style="width: 50px"
              />
            </router-link>
          </span>
          <div class="d-md-inline align-self-center">
            <span
              class="text-black font-weight-bolder font-size-h4 d-md-inline"
            >
              <router-link
                :to="`/customerView/${customerId}/documents`"
                v-slot="{ href, navigate, isActive, isExactActive }"
              >
                <a
                  :href="href"
                  class="service-box-link"
                  :class="[
                    isActive && 'service-box-item-active',
                    isExactActive && 'service-box-item-active'
                  ]"
                  @click="navigate"
                >
                  Landscape documents
                </a>
              </router-link>
            </span>
          </div>
        </div>
      </div>
      <div
        class="general-info-item  align-self-center"
        v-if="!isValenciaResident"
      >
        <div class="w-auto d-flex align-items-center mx-3">
          <div class="align-center">
            <div class="d-flex align-center">
              <v-rating v-model="rating" hover length="5" readonly>
                <template v-slot:item="props">
                  <img
                    height="58"
                    width="49"
                    :src="
                      props.isFilled
                        ? 'media/assets/active-leaf.png'
                        : props.isHalfFilled
                        ? 'media/assets/half-leaf.png'
                        : 'media/assets/inactive-leaf.png'
                    "
                  />
                </template>
              </v-rating>

              <div
                class="ml-5 pa-3 rounded-circle d-flex justify-center align-center black--text align-self-end"
                style="width:50px;"
              >
                <span class="text-h4 text-green font-weight-black">
                  {{ rating }}
                </span>
              </div>
            </div>
            <v-slider
              v-if="
                permissions &&
                  permissions.communitySentiment &&
                  permissions.communitySentiment.canEdit
              "
              v-model="rating"
              step="1"
              min="0"
              max="5"
              thumb-label
              ticks
              color="orange"
              track-color="orange"
              thumb-color="blue"
              hide-details="true"
              @change="onSentimentChange"
              @start="onStart"
            ></v-slider>
            <p class="display5 font-weight-boldest text-center pt-1">
              Landscape Sentiment
            </p>
            <v-dialog v-model="sentimentDialog" persistent max-width="400">
              <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                  <v-textarea
                    v-model="sentimentReason"
                    label="Please, briefly describe the reason(s) for this rating:"
                    :error-messages="sentimentReasonErrors"
                    @input="$v.sentimentReason.$touch()"
                    @blur="$v.sentimentReason.$touch()"
                    required
                  ></v-textarea>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :loading="messageProcessing"
                    color="green darken-1"
                    text
                    @click="sendMessage()"
                  >
                    Submit
                  </v-btn>
                  <v-btn
                    color="gray darken-1"
                    text
                    @click="cancelSentimentChange"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
      <div
        class="general-info-item border-left d-flex"
        v-if="!isValenciaResident"
      >
        <div class="align-self-center">
          <div class="w-auto d-flex align-items-center px-2">
            <span class="symbol symbol-auto symbol-light-success mx-3">
              <img
                alt="service status"
                :src="getServiceStatusIconPath(serviceStatus)"
              />
            </span>
            <div class="d-md-inline align-self-start">
              <span
                class="text-black font-weight-bolder font-size-h3 d-md-inline"
              >
                Service Status
              </span>
              <div class="text-center" v-if="serviceStatusLoading">
                <v-progress-circular
                  :active="serviceStatusLoading"
                  :indeterminate="serviceStatusLoading"
                  color="primary"
                >
                </v-progress-circular>
              </div>
              <div v-if="!serviceStatusLoading">
                <div class="text-orange font-weight-bolder font-size-h4">
                  {{ serviceStatus.status }}
                </div>
                <div>
                  <a
                    href="javascript:;"
                    class="blue--text"
                    @click.stop="getServiceStatusHistory"
                  >
                    Export History
                  </a>
                </div>
                <div
                  class="text-center mt-0"
                  v-if="serviceStatus.rescheduledText"
                >
                  {{ serviceStatus.rescheduledText }}
                </div>
              </div>
            </div>
          </div>
          <div class="w-auto d-flex align-items-center px-2 mt-3">
            <span class="symbol symbol-auto symbol-light-success mx-3">
              <img
                alt="Kudos"
                src="/media/assets/icons/icons_kudos_orange.png"
              />
            </span>
            <div class="d-md-inline align-self-center">
              <span
                class="text-green font-weight-bolder font-size-h3 d-md-inline"
              >
                <a href="#" @click="showKudosDialog">
                  Send Kudos
                </a>
              </span>
              <div>
                <router-link
                  :to="`/customerView/${customerId}/kudos`"
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" class="blue--text" @click="navigate">
                    View Kudos
                  </a>
                </router-link>
              </div>
            </div>
            <v-dialog v-model="sendKudosDialog" persistent max-width="400">
              <v-card elevation="0" outlined>
                <v-card-title
                  class="background-color-darkgrey text-white font-weight-bold text-center"
                >
                  <img
                    src="/media/assets/icons/icons_kudos_white.png"
                    style="width: 50px;"
                    class="mr-5"
                  />
                  Send Kudos
                </v-card-title>
                <v-card-text class="mt-3">
                  <!-- Start Send Kudos section -->
                  <v-form>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="kudos.communityName"
                            label="Community"
                            required
                            solo
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="kudos.from"
                            label="From"
                            :error-messages="fromErrors"
                            @input="$v.kudos.from.$touch()"
                            @blur="$v.kudos.from.$touch()"
                            required
                            solo
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea
                            v-model="kudos.body"
                            label="Message"
                            :error-messages="bodyErrors"
                            @input="$v.kudos.body.$touch()"
                            @blur="$v.kudos.body.$touch()"
                            required
                            solo
                            hide-details
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <a
                            href="#"
                            class="text-green"
                            @click="closeKudosDialog"
                            >Cancel
                          </a>
                          <v-btn
                            class="ml-5 background-color-green text-white"
                            @click="sendKudos"
                          >
                            Submit
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>

                  <!-- End Send Kudos section -->
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </div>

    <div
      class="help-desk d-flex-inline d-md-flex justify-start py-4"
      v-if="communityInfo.isServiceRequestsAllowed"
    >
      <div class="help-desk-item">
        <div class="w-auto d-flex align-items-center px-2">
          <span class="symbol symbol-80 symbol-light-success mx-3">
            <img
              alt="property help desk"
              src="/media/assets/icons/icons_property_help_desk_white.png"
            />
          </span>
          <div class="d-md-inline align-self-center">
            <span class="text-white font-weight-bolder font-size-h5 uppercase">
              property
            </span>
            <div class="text-white font-weight-bolder font-size-h1 uppercase">
              Help desk
            </div>
            <div class="text-white font-weight-bolder font-size-h5 uppercase">
              manager
            </div>
          </div>
        </div>
      </div>
      <div class="help-desk-item d-flex">
        <div class="w-auto align-self-center px-10">
          <div class="mx-3 d-inline ">
            <a href="#">
              <span class="text-white font-weight-bolder font-size-h3 d-block">
                <router-link
                  :to="`/customerView/${customerId}/requests`"
                  v-slot="{ href, navigate, isExactActive }"
                >
                  <a
                    :href="href"
                    class="text-white"
                    :class="[isExactActive && 'link-active']"
                    @click="navigate"
                  >
                    View All Requests
                    <img
                      class="ml-4"
                      src="/media/assets/icons/icons_green_triangle.png"
                      alt="All Requests"
                      width="20px"
                    />
                  </a>
                </router-link>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="help-desk-item d-flex">
        <div class="d-flex w-auto text-center align-self-center px-10">
          <div class="">
            <a href="#">
              <span class="text-white font-weight-bolder font-size-h4 d-block">
                <router-link
                  :to="`/customerView/${customerId}/requests/new`"
                  v-slot="{ href, navigate, isExactActive }"
                >
                  <a
                    :href="href"
                    class="text-white"
                    :class="[isExactActive && 'link-active']"
                    @click="navigate"
                  >
                    Submit New
                    <img
                      class="ml-4"
                      src="/media/assets/icons/icons_yellow_triangle.png"
                      alt="New Request"
                      width="20px"
                    />
                  </a>
                </router-link>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        permissions &&
          permissions.customerAccess &&
          permissions.customerAccess.canAccessCustomerActivityAlerts
      "
      class="customer-activity-alerts d-flex flex-wrap justify-start justify-md-space-between  my-0 py-0 border-bottom border-top"
    >
      <!-- <div class="customer-activity-alerts-item d-flex my-4">
        <div class="w-auto mx-3 align-self-center">
          <span
            class="font-size-h1 font-weight-boldest text-center pt-1 text-orange"
          >
            My Landscape Files
          </span>
        </div>
      </div> -->
      <div class="customer-activity-alerts-item d-flex  my-4">
        <div class="w-auto text-center px-2 align-self-center">
          <div class="mx-3">
            <a
              href="#"
              @click="showProposals"
              :class="[
                isProposalsActive && 'text-yellow',
                !isProposalsActive && 'text-black'
              ]"
            >
              <span class="symbol symbol-100 symbol-light-success">
                <img
                  alt="Proposals"
                  :src="
                    isProposalsActive
                      ? '/media/assets/icons/icons_land_files_proposal_active.png'
                      : '/media/assets/icons/icons_land_files_proposal.png'
                  "
                />
              </span>
              <span class="font-weight-bolder font-size-base d-block">
                Proposals
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="customer-activity-alerts-item d-flex my-4">
        <div class="w-auto text-center px-2 align-self-center">
          <div class="mx-3">
            <a
              href="#"
              @click="showOrangeReports"
              :class="[
                isOrangeReportsActive && 'text-yellow',
                !isOrangeReportsActive && 'text-black'
              ]"
            >
              <span class="symbol symbol-100 symbol-light-success">
                <img
                  alt="Orane Reports"
                  :src="
                    isOrangeReportsActive
                      ? '/media/assets/icons/icons_land_files_orange_reps_active.png'
                      : '/media/assets/icons/icons_land_files_orange_reps.png'
                  "
                />
              </span>
              <span class="font-weight-bolder font-size-base d-block">
                Orange Reports
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="customer-activity-alerts-item d-flex my-4">
        <div class="w-auto text-center px-2 align-self-center">
          <div class="mx-3">
            <a
              href="#"
              @click="showQuarterlyPlans"
              :class="[
                isQuarterlyPlansActive && 'text-yellow',
                !isQuarterlyPlansActive && 'text-black'
              ]"
            >
              <span class="symbol symbol-100 symbol-light-success">
                <img
                  alt="Quarterly Plan"
                  :src="
                    isQuarterlyPlansActive
                      ? '/media/assets/icons/icons_land_files_qrtly_plans_active.png'
                      : '/media/assets/icons/icons_land_files_qrtly_plans.png'
                  "
                />
              </span>
              <span class="font-weight-bolder font-size-base d-block">
                Quarterly Plans
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="customer-activity-alerts-item d-flex my-4">
        <div class="w-auto text-center px-2 align-self-center">
          <div class="mx-3">
            <a
              href="#"
              @click="showWalkThroughs"
              :class="[
                isWalkThroughsActive && 'text-yellow',
                !isWalkThroughsActive && 'text-black'
              ]"
            >
              <span class="symbol symbol-100 symbol-light-success">
                <img
                  alt="Orane Reports"
                  :src="
                    isWalkThroughsActive
                      ? '/media/assets/icons/icons_land_files_walk_thrus_active.png'
                      : '/media/assets/icons/icons_land_files_walk_thrus.png'
                  "
                />
              </span>
              <span class="font-weight-bolder font-size-base d-block">
                Walk-throughs
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="customer-activity-alerts-item d-flex my-4">
        <div class="w-auto text-center px-2 align-self-center">
          <div class="mx-3">
            <a
              href="#"
              @click="showInvoices"
              :class="[
                isInvoicesActive && 'text-yellow',
                !isInvoicesActive && 'text-black'
              ]"
            >
              <span
                class="symbol symbol-100 symbol-light-success position-relative"
              >
                <img
                  alt="Orane Reports"
                  :src="
                    isInvoicesActive
                      ? '/media/assets/icons/icons_land_files_invoices_active.png'
                      : '/media/assets/icons/icons_land_files_invoices.png'
                  "
                />
                <span
                  v-if="hasPastDue"
                  class="position-absolute top-0 right-0 background-color-orange text-white pa-1 mt-7"
                >
                  PAST DUE
                </span>
              </span>
              <span class="font-weight-bolder font-size-base d-block">
                Invoices
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="customer-activity-alerts-item d-none d-md-flex ">
        <div class="w-25 text-center px-2 my-0">
          <div class="my-0 mx-0">
            <img
              src="/media/assets/img_my_landscape_files.png"
              alt=""
              width="300px"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        isProposalsActive &&
          permissions &&
          permissions.customerAccess &&
          permissions.customerAccess.canAccessCustomerActivityAlerts
      "
    >
      <div class="collapsable-section py-4">
        <div>
          <span
            class="display5 font-weight-boldest"
            @click="isProposalsExpanded = !isProposalsExpanded"
          >
            {{ isProposalsExpanded ? "-" : "+" }} Proposals
          </span>
          <!-- <router-link
            class="ml-5"
            :to="`/customerView/${customerId}/proposals/new`"
            v-if="
              permissions &&
                permissions.proposal &&
                permissions.proposal.canCreate
            "
          >
            Upload New Proposal
          </router-link> -->
        </div>
      </div>
      <div
        class="py-2"
        v-if="
          isProposalsExpanded &&
            permissions &&
            permissions.customerAccess &&
            permissions.customerAccess.canAccessCustomerActivityAlerts
        "
      >
        <v-data-table
          :headers="proposalsHeaders"
          :items="proposalsRecords"
          item-key="id"
          :loading="isLoading"
          :server-items-length="totalProposalsRecords"
          :options.sync="proposalsOptions"
          loading-text="Loading... Please wait"
          class="elevation-1 styled-table"
        >
          <template #[`item.title`]="{ item }">
            <a target="_blank" :href="item.fileUrl">{{ item.title }}</a>
          </template>
          <template #[`item.amount`]="{ item }">
            {{ formatUsMoney(item.amount) }}
          </template>
          <template #[`item.proposalDate`]="{ item }">
            {{ formatDateUs(item.proposalDate) }}
          </template>
          <template #[`item.actions`]="{ item }">
            <span v-if="item.isApproved" class="green--text">Approved</span>
            <span v-if="item.isDeclined" class="red--text">Declined</span>
            <span v-if="item.isOnHold" class="blue--text">On-Hold</span>
            <v-btn
              small
              v-if="!item.isApproved && !item.isDeclined && !item.isOnHold"
              class="green white--text mr-1"
              @click.stop="item.approveDialog = true"
            >
              Approve
            </v-btn>
            <v-btn
              small
              v-if="!item.isApproved && !item.isDeclined && !item.isOnHold"
              class="blue white--text mr-1"
              @click.stop="item.declineDialog = true"
            >
              Decline
            </v-btn>
            <v-btn
              small
              v-if="!item.isApproved && !item.isDeclined && !item.isOnHold"
              class="blue white--text mr-1"
              @click.stop="item.onHoldDialog = true"
            >
              On-Hold
            </v-btn>
            <!-- <router-link
              :to="
                `/customerView/${customerId}/messages/new?recipient=${customerId}`
              "
            >
              <v-btn
                small
                v-if="!item.isApproved && !item.isDeclined && !item.isOnHold"
                class="blue white--text"
              >
                ?
              </v-btn>
            </router-link> -->
            <a :href="`mailto:${accountManagerEmail}`">
              <v-btn
                small
                v-if="!item.isApproved && !item.isDeclined && !item.isOnHold"
                class="blue white--text"
              >
                ?
              </v-btn>
            </a>

            <v-dialog v-model="item.approveDialog" persistent max-width="290">
              <v-card>
                <v-card-title></v-card-title>
                <v-card-text
                  >Are you sure you want to approve proposal {{ item.title }}?
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :loading="item.approveProcessing"
                    color="green darken-1"
                    text
                    @click="item.approveDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :loading="item.approveProcessing"
                    color="green darken-1"
                    text
                    @click="toggleApproveStatus(item)"
                  >
                    Confirm
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="item.declineDialog" persistent max-width="290">
              <v-card>
                <v-card-title></v-card-title>
                <v-card-text
                  >Are you sure you want to decline proposal {{ item.title }}?
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :loading="item.declineProcessing"
                    color="green darken-1"
                    text
                    @click="item.declineDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :loading="item.declineProcessing"
                    color="green darken-1"
                    text
                    @click="declineProposal(item)"
                  >
                    Confirm
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="item.onHoldDialog" persistent max-width="290">
              <v-card>
                <v-card-title></v-card-title>
                <v-card-text
                  >Are you sure you want to put proposal {{ item.title }} on
                  hold?
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    :loading="item.onHoldProcessing"
                    color="green darken-1"
                    text
                    @click="item.onHoldDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :loading="item.onHoldProcessing"
                    color="green darken-1"
                    text
                    @click="putProposalOnHold(item)"
                  >
                    Confirm
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </div>
    </div>

    <div
      v-if="
        isOrangeReportsActive &&
          permissions &&
          permissions.customerAccess &&
          permissions.customerAccess.canAccessCustomerActivityAlerts
      "
    >
      <div class="collapsable-section py-4">
        <div>
          <span
            class="display5 font-weight-boldest"
            @click="isOrangeReportsExpanded = !isOrangeReportsExpanded"
          >
            {{ isOrangeReportsExpanded ? "-" : "+" }} Orange Reports
          </span>
          <router-link
            class="ml-5"
            v-if="
              permissions.orangeReport && permissions.orangeReport.canCreate
            "
            :to="`/customerView/${customerId}/orange-reports/new`"
          >
            New Orange Report
          </router-link>
        </div>
      </div>
      <div class="py-2" v-if="isOrangeReportsExpanded">
        <v-progress-linear
          :active="orangeReportsLoading"
          :indeterminate="orangeReportsLoading"
          absolute
          bottom
        ></v-progress-linear>
        <div v-if="!orangeReportsLoading">
          <v-row v-if="sortedOrangeReports.length > 0">
            <v-col
              md="4"
              sm="6"
              cols="12"
              v-for="(item, i) in sortedOrangeReports"
              :key="'o' + i"
            >
              <div>
                <p class="mb-1">
                  {{ item.title }}
                  <br />
                  <router-link
                    class="orange--text"
                    :to="
                      `/customerView/${customerId}/orange-reports/${item.id}/view`
                    "
                  >
                    View
                  </router-link>
                  <!-- <router-link
                    v-else
                    class="green--text"
                    :to="
                      `/customerView/${customerId}/orange-reports/${item.id}/edit`
                    "
                  >
                    {{
                      permissions.orangeReport &&
                      permissions.orangeReport.canApprove
                        ? "Edit / Approve "
                        : "Edit "
                    }}
                  </router-link> -->
                </p>
                <router-link
                  class="orange--text"
                  :to="
                    `/customerView/${customerId}/orange-reports/${item.id}/${
                      item.isApproved ? 'view' : 'edit'
                    }`
                  "
                >
                  <v-img
                    height="200"
                    width="300"
                    :src="reportPicture(item)"
                  ></v-img>
                </router-link>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <div
      v-if="
        isQuarterlyPlansActive &&
          permissions &&
          permissions.customerAccess &&
          permissions.customerAccess.canAccessCustomerActivityAlerts
      "
    >
      <div class="collapsable-section py-4">
        <div>
          <span
            class="display5 font-weight-boldest"
            @click="isQuarterlyPlansExpanded = !isQuarterlyPlansExpanded"
          >
            {{ isQuarterlyPlansExpanded ? "-" : "+" }} Quarterly Plans
          </span>
          <router-link
            class="ml-4"
            v-if="
              permissions.ninetyDayPlan && permissions.ninetyDayPlan.canCreate
            "
            :to="`/customerView/${customerId}/plans/new`"
          >
            New Quarterly Plan
          </router-link>
          <router-link
            class="ml-4"
            v-if="
              permissions.ninetyDayPlan && permissions.ninetyDayPlan.canCreate
            "
            :to="`/customerView/${customerId}/planTemplates`"
          >
            New Quarterly Plan From Template
          </router-link>
        </div>
      </div>
      <div class="py-2" v-if="isQuarterlyPlansExpanded">
        <v-progress-linear
          :active="plansLoading"
          :indeterminate="plansLoading"
          absolute
          bottom
        ></v-progress-linear>
        <div v-if="!plansLoading">
          <v-row v-if="sortedNinetyDayPlans.length > 0">
            <div
              class="mx-4"
              v-for="(item, i) in sortedNinetyDayPlans"
              :key="'o' + i"
            >
              <div>
                <div class="d-flex justify-space-between">
                  <div>
                    <router-link
                      class="orange--text"
                      :to="`/customerView/${customerId}/plans/${item.id}/view`"
                    >
                      {{ item.title }}
                    </router-link>
                  </div>
                  <!-- <div v-if="item.isActive">
                    <router-link
                      class="blue--text"
                      v-if="
                        permissions.ninetyDayPlan &&
                          permissions.ninetyDayPlan.canCreate
                      "
                      :to="`/customerView/${customerId}/plans/${item.id}/edit`"
                    >
                      Update
                    </router-link>
                  </div> -->
                  <div v-if="!item.isActive">
                    <router-link
                      class="orange--text"
                      :to="`/customerView/${customerId}/plans/${item.id}/view`"
                    >
                      Complete
                    </router-link>
                  </div>
                </div>
                <router-link
                  class="orange--text"
                  :to="`/customerView/${customerId}/plans/${item.id}/view`"
                >
                  <v-img
                    height="200"
                    width="300"
                    :src="planPicture(item)"
                  ></v-img>
                </router-link>

                <!-- <p class="mt-2">
                  <router-link
                    class="blue--text"
                    v-if="
                      permissions.ninetyDayPlan &&
                        permissions.ninetyDayPlan.canCreate
                    "
                    :to="
                      `/customerView/${customerId}/plans/new?sourcePlanId=${item.id}`
                    "
                  >
                    Duplicate plan (new)
                  </router-link>
                </p> -->
              </div>
            </div>
          </v-row>
        </div>
      </div>
    </div>

    <div
      v-if="
        isWalkThroughsActive &&
          permissions &&
          permissions.customerAccess &&
          permissions.customerAccess.canAccessCustomerActivityAlerts
      "
    >
      <div class="collapsable-section py-4">
        <div>
          <span
            class="display5 font-weight-boldest"
            @click="isWalkThroughsExpanded = !isWalkThroughsExpanded"
          >
            {{ isWalkThroughsExpanded ? "-" : "+" }} Walk-Throughs
          </span>
          <router-link
            class="ml-4"
            v-if="
              permissions.ninetyDayPlan && permissions.ninetyDayPlan.canCreate
            "
            :to="`/customerView/${customerId}/walkthroughs/new`"
          >
            New Walk-through
          </router-link>
        </div>
      </div>
      <div class="py-2" v-if="isWalkThroughsExpanded">
        <v-progress-linear
          :active="walkThroughsLoading"
          :indeterminate="walkThroughsLoading"
          absolute
          bottom
        ></v-progress-linear>
        <div v-if="!walkThroughsLoading">
          <v-row v-if="sortedWalkThroughs.length > 0">
            <v-col
              md="2"
              sm="3"
              cols="4"
              v-for="(item, i) in sortedWalkThroughs"
              :key="'o' + i"
            >
              <div>
                <p>
                  {{ item.title }}
                  <br />
                  {{ formatDateUs(item.walkthroughDate) }}
                  <br />
                  <router-link
                    v-if="item.isApproved"
                    class="orange--text"
                    :to="
                      `/customerView/${customerId}/walkthroughs/${item.id}/view`
                    "
                  >
                    View Walk-Through
                  </router-link>
                  <router-link
                    v-else
                    class="green--text"
                    :to="
                      `/customerView/${customerId}/walkthroughs/${item.id}/edit`
                    "
                    >{{
                      permissions.orangeReport &&
                      permissions.orangeReport.canApprove
                        ? "Edit / Approve "
                        : "Edit "
                    }}
                    Walk-Trhough</router-link
                  >
                </p>
                <router-link
                  class="orange--text"
                  :to="
                    `/customerView/${customerId}/walkthroughs/${item.id}/${
                      item.isApproved ? 'view' : 'edit'
                    }`
                  "
                >
                  <span
                    class="symbol symbol-100 symbol-light-success position-relative"
                  >
                    <img
                      width="100"
                      :src="'/media/assets/icons/icons_walk_thrus.png'"
                    />
                  </span>
                </router-link>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <div
      v-if="
        isInvoicesActive &&
          permissions &&
          permissions.customerAccess &&
          permissions.customerAccess.canAccessCustomerActivityAlerts
      "
    >
      <div class="collapsable-section py-4">
        <div>
          <span
            class="display5 font-weight-boldest"
            @click="isInvoicesExpanded = !isInvoicesExpanded"
          >
            {{ isInvoicesExpanded ? "-" : "+" }} Invoices
          </span>
          <!-- <router-link
            class="ml-4"
            :to="`/customerView/${customerId}/invoices/new`"
            v-if="
              permissions &&
                permissions.invoice &&
                permissions.invoice.canCreate
            "
          >
            Upload New Invoice
          </router-link> -->
        </div>
      </div>
      <div class="py-2" v-if="isInvoicesExpanded">
        <v-row>
          <v-col cols="12" md="3">
            <v-select
              dense
              v-model="viewPeriod"
              :items="viewPeriodItems"
              item-text="name"
              item-value="value"
              label="Choose Period..."
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="3">
            <div v-if="viewPeriod == 'CD'">
              <v-menu
                ref="customDateMenu"
                v-model="customDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedCustomDates"
                    label="Choose date range"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="customDates" no-title range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="customDateMenu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.customDateMenu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>
        </v-row>
        <v-data-table
          :headers="invoicesHeaders"
          :items="invoicesRecords"
          item-key="id"
          :loading="isInvoicesLoading"
          :server-items-length="totalInvoicesRecords"
          :options.sync="invoicesOptions"
          loading-text="Loading... Please wait"
          class="elevation-1 styled-table"
        >
          <template #[`item.fileName`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{on, attrs}">
                <v-btn
                  v-if="!item.fileUrl"
                  class="ma-2"
                  text
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="downloadInvoice(item.id)"
                >
                  <v-icon color="red">mdi-download</v-icon>
                </v-btn>
                <a
                  v-else
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2 pa-2  "
                  target="_blank"
                  style="display: inline-block;"
                  :href="item.fileUrl"
                >
                  <v-icon color="red">mdi-download</v-icon>
                </a>
              </template>
              <span>Download Invoice</span>
            </v-tooltip>
            <!-- <a target="_blank" :href="item.fileUrl">{{ item.fileName }}</a> -->
          </template>
          <template #[`item.amountRemaining`]="{ item }">
            <span>{{ formatUsMoney(item.amountRemaining) }}</span>
          </template>
          <template #[`item.invoiceDate`]="{ item }">
            <span>{{ formatDateUs(item.invoiceDate) }}</span>
          </template>
          <template #[`item.dueDate`]="{ item }">
            <span>{{ formatDateUs(item.dueDate) }}</span>
          </template>
          <template #[`item.title`]="{ item }">
            <span>{{ item.title }}</span
            ><span
              v-if="
                new Date(item.dueDate) < new Date() && item.amountRemaining > 0
              "
              class="past-due-invoice mx-2 px-1 py-1"
              >Past Due</span
            >
          </template>
          <template #[`item.invoiceNumber`]="{ item }">
            <span>{{ item.invoiceNumber }}</span
            ><span
              v-if="
                new Date(item.dueDate) < new Date() && item.amountRemaining > 0
              "
              class="past-due-invoice mx-2 px-1 py-1"
              >Past Due</span
            >
          </template>
          <template #[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{on, attrs}">
                <a
                  v-if="
                    item &&
                      communityInfo &&
                      communityInfo.propertyManager &&
                      communityInfo.propertyManager.email
                  "
                  target="_blank"
                  :href="`mailto:${communityInfo.propertyManager.email}`"
                >
                  <v-icon class="mr-2" color="#31C0E3" v-bind="attrs" v-on="on">
                    mdi-email
                  </v-icon>
                </a>
                <!-- <router-link :to="`mailto:${communityInfo.propertyManager.email}`">
                  <v-icon class="mr-2" color="#31C0E3" v-bind="attrs" v-on="on">
                    mdi-email
                  </v-icon>
                </router-link> -->
              </template>
              <span>Email invoice</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{on, attrs}">
                <v-btn
                  v-if="item.fileUrl"
                  class="ma-2"
                  text
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="item.deleteDialog = true"
                >
                  <v-icon color="red">mdi-close-circle</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
            <v-dialog v-model="item.deleteDialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">
                  Delete Invoice
                </v-card-title>
                <v-card-text
                  >Are you sure you want to delete invoice:
                  <p>{{ item.title }}</p></v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="item.deleteDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="deleteInvoice(item)"
                  >
                    Delete
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </div>
    </div>

    <!-- </v-container> -->
  </div>
</template>

<style lang="scss">
.help-desk-item,
.comunity-info-manager {
  line-height: 1;
}
</style>

<script>
// import CommunityInfo from "@/view/components/customerView/CommunityInfo.vue";
import {
  DELETE,
  GET_QUERY,
  API_CUSTOMERS,
  API_MESSAGES,
  POST_DATA,
  API_KUDOS,
  API_SERVICE_REQUESTS,
  API_SERVICE_REQUEST_PRIORITIES,
  API_SERVICE_REQUEST_TYPES,
  API_INVOICES
} from "@/core/store/crud.module";
import crud from "@/core/helpers/crud";

// import { API_USERS } from "@/core/store/crud.module";
import dateFormatter from "@/core/helpers/dateFormatter";
import stringFormatter from "@/core/helpers/stringFormatter";
import { validationMixin } from "vuelidate";
import permissionsHelper from "@/core/helpers/permissionsHelper";
// import dataModels from "@/core/helpers/datamodels.js";

import { required } from "vuelidate/lib/validators";
import moment from "moment";
import Mgr from "@/core/services/security.service";
// import Konva from "konva";

export default {
  mixins: [validationMixin],
  components: {
    // CommunityInfo
  },
  data: () => ({
    configKonva: {
      width: 800,
      height: 600
    },
    userInfo: null,
    communityInfo: {},
    sentimentDialog: false,

    proposalsRecords: [],
    totalProposalsRecords: 0,
    proposalsOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ["proposalDate"],
      sortDesc: [true]
    },
    proposalsHeaders: [
      { text: "Date", value: "proposalDate", class: "orange-bg" },
      { text: "Name", value: "title", class: "orange-bg" },
      { text: "Amount", value: "amount", class: "orange-bg" },
      { text: "Actions", value: "actions", sortable: false, class: "orange-bg" }
    ],
    newRequest: {
      communityName: "",
      title: "",
      requestType: "",
      description: "",
      isInternal: false,
      attachments: [],
      priority: "",
      assignedTo: "",
      targetCompletitioDate: null
    },

    requestTypeItems: [],
    priorityItems: [],

    customDateMenu: false,
    customDates: [],
    formattedCustomDates: "",

    serviceRequestProcessing: false,
    loadingPriorityItems: false,
    loadingServiceRequestTypes: false,

    orangeReports: [],
    sortedOrangeReports: [],
    orangeReportsLoading: false,

    ninetyDayPlans: [],
    sortedNinetyDayPlans: [],
    plansLoading: false,
    activePlanId: null,

    walkThroughs: [],
    sortedWalkThroughs: [],
    walkThroughsLoading: false,

    isInvoicesLoading: false,
    invoicesHeaders: [
      { text: "Due  Date", value: "dueDate", class: "orange-bg" },
      { text: "Invoice Number", value: "invoiceNumber", class: "orange-bg" },
      { text: "$ Amount Due", value: "amountRemaining", class: "orange-bg" },
      // { text: "Property Name", value: "propertyName", class: "orange-bg" },
      // {
      //   text: "Property Manager",
      //   value: "propertyManager",
      //   class: "orange-bg"
      // },
      // {
      //   text: "Management Company",
      //   value: "managementCompany",
      //   class: "orange-bg"
      // },
      // { text: "Phone", value: "phone", class: "orange-bg" },
      { text: "Invoice", value: "fileName", class: "orange-bg" }
      // { text: "Actions", value: "actions", sortable: false, class: "orange-bg" }
    ],
    // [
    //   { text: "Due  Date", value: "dueDate", class: "orange-bg" },
    //   { text: "Invoice Number", value: "invoiceNumber", class: "orange-bg" },
    //   { text: "$ Amount Due", value: "amountRemaining", class: "orange-bg" },
    //   { text: "Property Name", value: "propertyName", class: "orange-bg" },
    //   // { text: "Name", value: "title", class: "orange-bg" },
    //   // { text: "Date", value: "invoiceDate", class: "orange-bg" },

    //   { text: "Invoice", value: "fileName", class: "orange-bg" }
    //   // { text: "Actions", value: "actions", sortable: false, class: "orange-bg" }
    // ],
    viewPeriod: "YTD",
    viewPeriodItems: [
      { name: "View last month", value: "LM" },
      { name: "View last quarter", value: "LQ" },
      { name: "View last year", value: "LY" },
      { name: "View year to date", value: "YTD" }
      // { name: "Custom date", value: "CD" }
    ],
    invoicesOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ["invoiceDate"],
      sortDesc: [true]
    },

    invoicesRecords: [],
    totalInvoicesRecords: 0,

    isProposalsExpanded: true,

    isOrangeReportsExpanded: false,

    isQuarterlyPlansExpanded: false,

    isWalkThroughsExpanded: false,

    isInvoicesExpanded: false,
    activeSection: "proposals",

    permissions: {},
    sentimentReason: "",
    messageProcessing: false,

    baseUrl: `${process.env.VUE_APP_DASHBOARD_URL}`,
    loading: false,
    snackbarContent: "",
    snackbarColor: "#F06835",
    dbOrangeReportServices: [],
    renderedServices: [],

    serviceStatus: {},
    serviceStatusLoading: false,

    sendKudosDialog: false,
    kudos: {
      community: "",
      from: "",
      body: ""
    },
    mgr: new Mgr(),
    hasPastDue: false,
    rating: 0
  }),
  props: {
    customerId: {
      type: [Number, String],
      default: 0
    }
  },
  validations() {
    return {
      sentimentReason: {
        required
      },
      kudos: {
        from: {
          required
        },
        body: {
          required
        }
      }
    };
  },
  watch: {
    proposalsOptions: async function() {
      await this.getProposalsRecords();
    },
    invoicesOptions: async function() {
      if (!this.isInvoicesLoading) await this.getInvoicesRecords();
    },
    viewPeriod: async function() {
      if (!this.isInvoicesLoading) await this.getInvoicesRecords();
    }
  },
  async mounted() {
    this.getServiceStatus();
    this.getProposalsRecords();

    // this.getServiceRequestPriorities();
    // this.getServiceRequestTypes();

    // this.getMapData();
    this.getPastDueInvoicesNumbers();
  },
  async created() {
    this.permissions = await permissionsHelper.getPermissions();
    this.userInfo = await this.mgr.getUser();
    await this.getComunityInfo();
  },
  methods: {
    async getServiceStatusHistory() {
      let self = this;

      let url = `${API_CUSTOMERS}/${this.customerId}/serviceStatusHistory`;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: url
        })
        .then(response => {
          // console.log(response);
          // console.log("response.data", response.data);
          let records = [];
          if (response.status >= 200 || response.status <= 204) {
            let items = response.data;
            records = items;
          } else {
            self.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          {
            // Create a Blob with the CSV data and type
            const blob = new Blob([records], { type: "text/csv" });

            // Create a URL for the Blob
            const url = URL.createObjectURL(blob);

            // Create an anchor tag for downloading
            const a = document.createElement("a");

            // Set the URL and download attribute of the anchor tag
            a.href = url;
            a.download =
              "export_status_history_" + new Date().toISOString() + ".csv";
            // Trigger the download by clicking the anchor tag
            a.click();
            return;
          }
        });
    },
    async getPastDueInvoicesNumbers() {
      // if (this.pastDueInvoicesLoading) return;

      // this.pastDueInvoicesLoading = true;
      let self = this;

      let url = `${API_INVOICES}/ForProperty/${this.customerId}/numbers`;
      // if (this.customerId && customerId != 0) {
      //   url = `${API_INVOICES}/ForProperty/${this.customerId}/numbers`;
      // }

      await this.$store
        .dispatch(GET_QUERY, {
          listName: `${url}`
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            let numbers = response.data;

            self.hasPastDue = numbers.pastDue > 0;
          }

          // self.pastDueInvoicesLoading = false;
        })
        .catch(err => {
          this.$snackbar.showMessage({
            content: err
          });
          // self.pastDueInvoicesLoading = false;
        });
    },
    closeKudosDialog() {
      this.kudos = {
        body: ""
      };
      this.sendKudosDialog = false;
    },
    async showKudosDialog(event) {
      event.preventDefault();
      // this.userInfo = await this.mgr.getUser();
      this.kudos.from =
        this.userInfo.profile.fullName +
        " <" +
        this.userInfo.profile.email +
        ">";

      this.kudos.communityName = this.communityInfo.name;

      this.sendKudosDialog = true;
    },
    sendKudos() {
      this.$v.kudos.$touch();
      if (this.$v.kudos.$invalid) {
        return;
      }

      this.kudos.communityId = this.customerId;

      let self = this;
      this.$store
        .dispatch(POST_DATA, {
          listName: `${API_KUDOS}`,
          data: self.kudos
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            self.snackbarContent =
              "Thank you for sending us some kudos. We appreciate the opportunity to serve you. Your message will be sent to your Account Manager and the Yardnique management team.";
          } else {
            self.snackbarContent = response.data;
            self.snackbarColor = "red";
          }
          self.$snackbar.showMessage({
            content: self.snackbarContent,
            color: self.snackbarColor
          });
          this.sendKudosDialog = false;
        });
    },
    getMailToLink(email) {
      return `mailto:${email}`;
    },
    async showProposals(event) {
      event.preventDefault();

      this.activeSection = "proposals";
      this.isProposalsExpanded = true;

      await this.getProposalsRecords();
    },
    async showOrangeReports(event) {
      event.preventDefault();

      this.activeSection = "orangeReports";
      this.isOrangeReportsExpanded = true;

      await this.getRecentOrangeReports();
    },
    async showQuarterlyPlans(event) {
      event.preventDefault();

      this.activeSection = "quarterlyPlans";
      this.isQuarterlyPlansExpanded = true;

      await this.getPlans();
    },
    async showWalkThroughs(event) {
      event.preventDefault();

      this.activeSection = "walkThroughs";
      this.isWalkThroughsExpanded = true;

      await this.getRecentWalkThroughs();
    },
    async showInvoices(event) {
      event.preventDefault();

      this.activeSection = "invoices";
      this.isInvoicesExpanded = true;

      await this.getInvoicesRecords();
    },
    async getRecentOrangeReports() {
      // if (this.orangeReportsLoading) return;
      this.orangeReportsLoading = true;

      let reportsUrl = `${API_CUSTOMERS}/${this.customerId}/orangeReports`;
      await this.$store
        .dispatch(GET_QUERY, {
          listName: reportsUrl
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.recentOrangeReports = response.data.$values.filter(
              el => el.isApproved
            );

            this.sortedOrangeReports = this.recentOrangeReports
              .slice()
              .sort((a, b) => {
                return new Date(b.serviceDate) - new Date(a.serviceDate);
              });
          } else {
            this.$snackbar.showMessage({
              content:
                response.data ||
                "Cannot receive recent Orange Reports. Something went wrong!",
              color: "red"
            });
          }

          this.orangeReportsLoading = false;
        });
    },
    getLastQuarter() {
      let today = new Date(),
        quarter = Math.floor(today.getMonth() / 3);

      let startDate = new Date(today.getFullYear(), quarter * 3 - 3, 1);
      let endDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 3,
        0
      );
      return {
        startDate: startDate,
        endDate: endDate
      };
    },
    async getInvoicesRecords() {
      this.isInvoicesLoading = true;

      let self = this;
      let url = `${API_CUSTOMERS}/${this.customerId}/invoices`;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: url
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            const {
              sortBy,
              sortDesc,
              page,
              itemsPerPage
            } = this.invoicesOptions;

            let currentDate = new Date();
            currentDate.setHours(0, 0, 0);
            let startPeriod = new Date(new Date().setDate(-30));
            startPeriod.setHours(0, 0, 0);
            let endPeriod = new Date();
            endPeriod.setHours(0, 0, 0);
            switch (self.viewPeriod) {
              case "LY":
                startPeriod = new Date(currentDate.getFullYear() - 1, 0, 1);
                endPeriod = new Date(currentDate.getFullYear() - 1, 11, 31);
                break;
              case "LQ":
                startPeriod = this.getLastQuarter().startDate;
                break;
              case "YTD":
                startPeriod = new Date(currentDate.getFullYear(), 0, 1);
                break;
              case "CD":
                if (self.customDates.length > 0) {
                  startPeriod = new Date(self.customDates[0]);
                  if (self.customDates.length > 1)
                    endPeriod = new Date(self.customDates[1]);
                }

                break;
              //case "LM":break; apply in default
              default:
                break;
            }

            response.data.forEach(function(element) {
              element.deleteDialog = false;
              element.isPastDue =
                new Date(element.dueDate) < new Date() &&
                element.amountRemaining > 0;
            });

            let items = response.data;

            items = items.filter(
              el =>
                new Date(el.invoiceDate) >= new Date(startPeriod) &&
                new Date(el.invoiceDate) <= new Date(endPeriod)
            );

            self.totalInvoicesRecords = items.length;

            if (sortBy.length === 1 && sortDesc.length === 1) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy[0]];
                const sortB = b[sortBy[0]];

                if (sortDesc[0]) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });

              if (sortBy[0] == "invoiceDate") {
                items = items.sort((a, b) => {
                  // const sortA = a[sortBy[0]];
                  // const sortB = b[sortBy[0]];

                  const pastDueA = a["isPastDue"];
                  const pastDueB = b["isPastDue"];

                  if (sortDesc[0]) {
                    if (pastDueA < pastDueB) return 1;
                    if (pastDueA > pastDueB) return -1;
                    return 0;
                  } else {
                    if (pastDueA < pastDueB) return -1;
                    if (pastDueA > pastDueB) return 1;
                    return 0;
                  }
                });
              }
            }

            if (itemsPerPage > 0) {
              items = items.slice(
                (page - 1) * itemsPerPage,
                page * itemsPerPage
              );
            }

            self.invoicesRecords = items;
          } else {
            self.$snackbar.showMessage({
              content:
                response.data ||
                "Cannot receive a list of invoices. Something went wrong!",
              color: "red"
            });
          }

          self.isInvoicesLoading = false;
        });
    },
    async downloadInvoice(invoiceId) {
      let pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      // var htmlToPdfmake = require("html-to-pdfmake");

      let self = this;
      let url = `${API_CUSTOMERS}/${self.customerId}/invoices/${invoiceId}`;

      let invoiceResponse = await self.$store.dispatch(GET_QUERY, {
        listName: url
      });
      // console.log(invoiceResponse);

      let invoice = invoiceResponse.data.aspireInvoice;

      // // const {convert} = require("html-to-text");
      // let myHTML = invoice.invoiceOpportunities[0].description;

      // var strippedHtml = myHTML.replace(/<[^>]+>/g, "");

      pdfMake.fonts = {
        // yourFontName: {
        //   normal: 'https://example.com/fonts/fontFile.ttf',
        //   bold: 'https://example.com/fonts/fontFile2.ttf',
        //   italics: 'https://example.com/fonts/fontFile3.ttf',
        //   bolditalics: 'https://example.com/fonts/fontFile4.ttf'
        // },
        Fontello: {
          normal: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          bold: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          italics: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          bolditalics:
            self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf"
        },

        //download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf"
        },
        Arial: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf"
        }
      };

      // let serviceDateModified = new Date(self.orangeReport.serviceDate)
      //   .toISOString()
      //   .substr(0, 10);

      let invoiceItemsBody = [];
      let header = [];
      header.push({
        text: "QTY",
        fillColor: "#778799",
        color: "white",
        alignment: "right",
        border: [false, false, false, true]
      });
      header.push({
        text: "ITEM",
        fillColor: "#778799",
        color: "white",
        alignment: "left",
        border: [false, false, false, true]
      });
      header.push({
        text: "EXT PRICE",
        fillColor: "#778799",
        color: "white",
        alignment: "center",
        border: [false, false, false, true]
      });
      header.push({
        text: "LINE TOTAL",
        fillColor: "#778799",
        color: "white",
        alignment: "center",
        border: [false, false, false, true]
      });

      invoiceItemsBody.push(header);

      if (
        invoice.invoiceOpportunities &&
        invoice.invoiceOpportunities.length > 0
      ) {
        invoice.invoiceOpportunities.forEach(function(item) {
          // let convertedDescr = htmlToPdfmake(item.description);
          // console.log(convertedDescr)
          let descriptionStr = item.description
            .replace(/<br[/]>/g, "\n")
            .replace(/<div/g, "\n<div")
            .replace(/<p/g, "\n<p")
            .replace(/<strong>/g, "[strong]")
            .replace(/<[^>]+>/g, "")
            .replace(/\n\n/g, "\n")
            .replace("\n", " ")
            .replace(/&nbsp;/g, " ");

          let descrptionStringArray = descriptionStr.split("\n");
          // console.log(descrptionStringArray);
          for (let i = 0; i < descrptionStringArray.length; i++) {
            let row = [];
            row.push({ text: "", border: [false, false, false, false] });
            let tmp = descrptionStringArray[i];
            if (tmp.includes("[strong]"))
              row.push({
                text: descrptionStringArray[i].replace("[strong]", ""),
                bold: true,
                border: [false, false, false, false]
              });
            else
              row.push({
                text: descrptionStringArray[i],
                border: [false, false, false, false]
              });
            if (i == 0) {
              row.push({
                alignment: "right",
                text:
                  "$" +
                  item.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"),
                bold: true,
                border: [false, false, false, false]
              });
              row.push({
                alignment: "right",
                text:
                  "$" +
                  item.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"),
                bold: true,
                border: [false, false, false, false]
              });
            } else {
              row.push({ text: "", border: [false, false, false, false] });
              row.push({ text: "", border: [false, false, false, false] });
            }

            invoiceItemsBody.push(row);
          }

          if (
            item.invoiceOpportunityServices &&
            item.invoiceOpportunityServices.length > 0
          ) {
            item.invoiceOpportunityServices.forEach(function(subItem) {
              let row = [];
              row.push({ text: "", border: [false, false, false, false] });
              row.push({
                margin: [5, 0, 0, 0],
                italics: true,
                text: subItem.description
                  .replace(/</g, "\n<")
                  .replace(/<[^>]+>/g, "")
                  .replace(/\n\n/g, "\n")
                  .replace("\n", " "),
                border: [false, false, false, false]
              });
              row.push({
                alignment: "right",
                italics: true,
                text:
                  "$" +
                  subItem.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"),
                border: [false, false, false, false]
              });
              row.push({
                alignment: "right",
                italics: true,
                text:
                  "$" +
                  subItem.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"),
                border: [false, false, false, false]
              });
              invoiceItemsBody.push(row);
            });
          }
        });
      }

      invoiceItemsBody.push([
        { text: "", border: [false, true, false, false] },
        { text: "Total", bold: true, border: [false, true, false, false] },
        {
          alignment: "right",
          text:
            "$" +
            invoice.origAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"),
          bold: true,
          border: [false, true, false, false]
        },
        {
          alignment: "right",
          text:
            "$" +
            invoice.origAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"),
          bold: true,
          border: [false, true, false, false]
        }
      ]);

      invoiceItemsBody.push([
        { text: "", border: [false, false, false, false] },
        {
          text: "Amount Paid",
          bold: true,
          border: [false, false, false, false]
        },
        { text: "", bold: true, border: [false, false, false, false] },
        {
          alignment: "right",
          text:
            "$" +
            (invoice.origAmount - invoice.amountRemaining)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,"),
          bold: true,
          border: [false, false, false, false]
        }
      ]);

      invoiceItemsBody.push([
        { text: "", border: [false, false, false, false] },
        {
          text: "Total Balance",
          bold: true,
          border: [false, false, false, false]
        },
        { text: "", bold: true, border: [false, false, false, false] },
        {
          alignment: "right",
          text:
            "$" +
            invoice.amountRemaining
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,"),
          bold: true,
          border: [false, false, false, false]
        }
      ]);

      //   let invoiceItems = invoice.invoiceOpportunities.map(item => {
      //   return [
      //     { text: "" },
      //     {
      //       text: item.description.replace(/</g, "\n<").replace(/<[^>]+>/g, "")
      //     },
      //     { text: item.amount },
      //     { text: item.amount }
      //   ];
      // });

      // console.log(JSON.stringify(invoiceItems));
      // let str = JSON.stringify(invoice);

      let branch = {
        logo: "yardniqueLogo", //self.baseUrl + "/media/logos/yardnique-logo.png",
        address: "10014 Chapel Hill Road",
        city: "Morrisville",
        state: "NC",
        zip: "27560"
      };

      switch (invoice.branchCode) {
        case "LMG":
        case "LMNC":
        case "LMSC":
          branch = {
            logo: "landmarkLogo", //self.baseUrl + "/media/logos/landmark-logo.png",
            address: "559 S Cemetery St",
            city: "Norcross",
            state: "GA",
            zip: "30071"
          };
          break;
        case "NTG":
          branch = {
            logo: "nativegreenLogo", //self.baseUrl + "/media/logos/nativegreen-logo.png",
            address: "3095 Oleander Ave",
            city: "Fort Pierrce",
            state: "FL",
            zip: "34982"
          };
          break;
        case "OCO":
        case "LIL":
        case "MAR":
        case "SUN":
          branch = {
            logo: "nscapesLogo", //self.baseUrl + "/media/logos/nscapes-logo.png",
            address: "1270 Turner Rd, Ste. A",
            city: "Lilburn",
            state: "GA",
            zip: "30047"
          };
          break;
        case "PHX":
          branch = {
            logo: "phoenixLogo", //self.baseUrl + "/media/logos/phoenix-logo.png",
            address: "1728 Castle Hayne Road",
            city: "Wilmington",
            state: "NC",
            zip: "28401"
          };
          break;
        case "TMCEN":
        case "TMG":
        case "TMNE":
        case "TMSE":
        case "Orland":
          // branch = {
          //   logo: "trimacLogo", //self.baseUrl + "/media/logos/trimac-logo.png",
          //   address: "PO BOX 8699",
          //   city: "Fleming Island",
          //   state: "FL",
          //   zip: "32006"
          // };
          // break;
          branch = {
            logo: "yardniqueLogo", //self.baseUrl + "/media/logos/yardnique-logo.png",
            address: "10014 Chapel Hill Road",
            city: "Morrisville",
            state: "NC",
            zip: "27560"
          };
          break;
        case "APX":
        case "CHS":
        case "CSTI":
        case "CRD":
        case "ADM":
        case "GRG":
        case "GRB":
        case "APS":
        case "MOR":
        case "RIR":
        case "MRT":
        case "OCA":
        case "SAVCOL":
        case "ILM":
          branch = {
            logo: "yardniqueLogo", //self.baseUrl + "/media/logos/yardnique-logo.png",
            address: "10014 Chapel Hill Road",
            city: "Morrisville",
            state: "NC",
            zip: "27560"
          };
          break;
      }

      let docDefinition = {
        images: {
          // yardniqueLogo: self.baseUrl + "/media/logos/yardnique-logo.png",
          // trimacLogo: self.baseUrl + "/media/logos/trimac-logo.png",
          // phoenixLogo: self.baseUrl + "/media/logos/phoenix-logo.png",
          // nscapesLogo: self.baseUrl + "/media/logos/nscapes-logo.png",
          // nativegreenLogo: self.baseUrl + "/media/logos/nativegreen-logo.png",
          // landmarkLogo: self.baseUrl + "/media/logos/landmark-logo.png"
          yardniqueLogo: self.baseUrl + "/media/logos/yn_leaf_logo.png",
          trimacLogo: self.baseUrl + "/media/logos/yn_leaf_logo.png",
          phoenixLogo: self.baseUrl + "/media/logos/yn_leaf_logo.png",
          nscapesLogo: self.baseUrl + "/media/logos/yn_leaf_logo.png",
          nativegreenLogo: self.baseUrl + "/media/logos/yn_leaf_logo.png",
          landmarkLogo: self.baseUrl + "/media/logos/yn_leaf_logo.png"
        },
        pageSize: "LETTER",
        pageMargins: [20, 20, 20, 20],
        content: [
          {
            // text: branch.address.toUpperCase(),
            // fontSize: 15,
            // bold: true
          },
          {
            columns: [
              {
                width: "*",
                stack: [
                  {
                    columns: [
                      {
                        width: "auto",
                        stack: [
                          {
                            image: branch.logo,
                            width: 100,
                            margin: [5, 0, 5, 0]
                          }
                        ]
                      },
                      {
                        width: "*",
                        stack: [
                          {
                            text: branch.address,
                            alignment: "left",
                            margin: [10, 10, 0, 0],
                            fontSize: 10
                          },
                          {
                            text:
                              branch.city +
                              " ," +
                              branch.state +
                              " " +
                              branch.zip,
                            alignment: "left",
                            margin: [10, 0, 0, 0],
                            fontSize: 10
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                width: "auto",
                stack: [
                  {
                    text: "INVOICE",
                    alignment: "center",
                    margin: [5, 5, 5, 5]
                  },
                  {
                    table: {
                      body: [
                        [
                          {
                            text: "Date",
                            fillColor: "#778799",
                            color: "white",
                            alignment: "center"
                          },
                          {
                            text: "Invoice No.",
                            fillColor: "#778799",
                            color: "white"
                          }
                        ],
                        [
                          moment(invoice.invoiceDate).format("MM/D/YYYY"),
                          invoice.invoiceNumber
                        ],
                        [
                          {
                            text: "Terms",
                            fillColor: "#778799",
                            color: "white",
                            alignment: "center"
                          },
                          {
                            text: "Due Date",
                            fillColor: "#778799",
                            color: "white",
                            alignment: "center"
                          }
                        ],
                        [invoice.paymentTermsName, invoice.dueDate || "---"]
                      ]
                    }
                  }
                ]
              }
            ]
          },
          "\n",
          {
            columns: [
              {
                width: "*",
                text: ""
              },
              {
                width: "auto",
                table: {
                  widths: [200],
                  body: [
                    [
                      {
                        text: "Property",
                        fillColor: "#778799",
                        color: "white",
                        alignment: "center"
                      }
                    ],
                    [
                      `${invoice.propertyName}\n${self.communityInfo.branchOfficeStaff?.communityAddress}\n${self.communityInfo.branchOfficeStaff?.communityCity}, ${self.communityInfo.branchOfficeStaff?.communityStateCode}, ${self.communityInfo.branchOfficeStaff?.communityPostalCode}`
                    ]
                  ]
                }
              }
            ]
          },
          "\n",
          {
            columns: [
              {
                width: "*",
                table: {
                  widths: [200],
                  body: [
                    [
                      {
                        text: "Bill To",
                        fillColor: "#778799",
                        color: "white",
                        alignment: "center"
                      }
                    ],
                    [
                      invoice.billingContactName +
                        "\n\n" +
                        invoice.companyName +
                        "\n" +
                        invoice.addressLine1 +
                        "\n" +
                        invoice.city +
                        ", " +
                        invoice.stateProvinceCode +
                        " " +
                        invoice.zipCode
                    ]
                  ]
                }
              },
              {
                width: "auto",
                table: {
                  body: [
                    [
                      {
                        text: "Amount Due",
                        fillColor: "#778799",
                        color: "white",
                        alignment: "center"
                      },
                      {
                        text: "Customer PO #",
                        fillColor: "#778799",
                        color: "white",
                        alignment: "center"
                      }
                    ],
                    [
                      "$" +
                        (invoice.amount || 0)
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$&,"),
                      ""
                    ]
                  ]
                }
              }
            ]
          },
          {
            alignment: "center",
            text: "\n\nPlease detach top portion and return with your payment.",
            italics: true
          },
          {
            alignment: "center",
            text:
              "----------------------------------------------------------------------"
          },
          "\n",
          {
            table: {
              widths: [20, "*", 50, 50],
              headerRows: 1,

              body: invoiceItemsBody
            }
          },
          "\n\n"
        ],
        defaultStyle: {
          fontSize: 8,
          bold: false
        },
        styles: {
          heading: {
            color: "#E06521",
            bold: true,
            margin: [0, 0, 0, 5]
          },
          icon: { font: "Fontello" },
          photos: {
            margin: [0, 10, 0, 10]
          },
          mt5: { margin: [0, 5, 0, 0] },
          mt10: { margin: [0, 10, 0, 0] },
          mb5: { margin: [0, 0, 0, 5] },
          mb10: { margin: [0, 0, 0, 10] },
          my5: { margin: [0, 5, 0, 5] },
          my10: { margin: [0, 10, 0, 10] }
        }
      };
      pdfMake.createPdf(docDefinition).open();
    },
    deleteInvoice(item) {
      let self = this;

      if (!item) return;

      let url = `${API_CUSTOMERS}/${this.customerId}/invoices`;

      this.$store
        .dispatch(DELETE, {
          listName: url,
          id: item.id
        })
        .then(function() {
          item.deleteDialog = false;

          self.getInvoicesRecords();
        });
    },
    async activatePlan() {
      this.plansLoading = true;

      let plansUrl = `${API_CUSTOMERS}/${this.customerId}/plans/${this.activePlanId}/activate`;
      await this.$store
        .dispatch(POST_DATA, {
          listName: plansUrl
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            for (let i = 0; i < this.ninetyDayPlans.length; i++) {
              this.ninetyDayPlans[i].isActive =
                this.ninetyDayPlans[i].id == this.activePlanId;
            }
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.plansLoading = false;
        });
    },
    async getPlans() {
      this.plansLoading = true;

      let plansUrl = `${API_CUSTOMERS}/${this.customerId}/plans`;
      await this.$store
        .dispatch(GET_QUERY, {
          listName: plansUrl
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.ninetyDayPlans = response.data.$values;

            this.sortedNinetyDayPlans = this.ninetyDayPlans
              .slice()
              .sort((a, b) => {
                return new Date(b.startDate) - new Date(a.startDate);
              });
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.plansLoading = false;
        });
    },
    planPicture(plan) {
      let defaultPicture =
        "https://cdn.vuetifyjs.com/images/parallax/material2.jpg";
      if (!plan) return defaultPicture;

      if (plan.photos.$values.length > 0) return plan.photos.$values[0].fileUrl;

      return defaultPicture;
    },

    async getRecentWalkThroughs() {
      this.walkThroughsLoading = true;

      let reportsUrl = `${API_CUSTOMERS}/${this.customerId}/walkThroughs`;
      await this.$store
        .dispatch(GET_QUERY, {
          listName: reportsUrl
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.walkThroughs = response.data.$values.filter(
              el => el.isApproved
            );
            this.sortedWalkThroughs = this.walkThroughs.slice().sort((a, b) => {
              return new Date(b.walkthroughDate) - new Date(a.walkthroughDate);
            });
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.walkThroughsLoading = false;
        });
    },
    walkThroughPicture(report) {
      let defaultPicture =
        "https://cdn.vuetifyjs.com/images/parallax/material2.jpg";
      if (!report) return defaultPicture;

      return defaultPicture;
    },
    async getServiceRequestPriorities() {
      this.loadingPriorityItems = true;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_SERVICE_REQUEST_PRIORITIES
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.priorityItems = response.data.$values;
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }
          this.loadingPriorityItems = false;
        });
    },
    async getServiceRequestTypes() {
      this.loadingServiceRequestTypes = true;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_SERVICE_REQUEST_TYPES
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.requestTypeItems = response.data.$values;
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }
          this.loadingServiceRequestTypes = false;
        });
    },
    getPermissions(permissionsObj) {
      this.permissions = permissionsObj;
    },
    async getProposalsRecords() {
      this.isLoading = true;

      let self = this;
      let url = `${API_CUSTOMERS}/${this.customerId}/proposals`;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: url
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            const {
              sortBy,
              sortDesc,
              page,
              itemsPerPage
            } = this.proposalsOptions;

            let items = response.data;

            self.totalProposalsRecords = items.length;

            items.forEach(el => {
              el.approveDialog = false;
              el.approveProcessing = false;

              el.declineDialog = false;
              el.declineProcessing = false;

              el.onHoldDialog = false;
              el.onHoldProcessing = false;
            });

            if (sortBy.length === 1 && sortDesc.length === 1) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy[0]];
                const sortB = b[sortBy[0]];

                if (sortDesc[0]) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            if (itemsPerPage > 0) {
              items = items.slice(
                (page - 1) * itemsPerPage,
                page * itemsPerPage
              );
            }

            self.proposalsRecords = items;
          } else {
            self.$snackbar.showMessage({
              content:
                response.data ||
                "Cannot receive a list of proposals. Something went wrong!",
              color: "red"
            });
          }

          self.isLoading = false;
        });
    },

    async toggleApproveStatus(item) {
      item.approveProcessing = true;
      let url = `${API_CUSTOMERS}/${this.customerId}/proposals/${item.id}/approve`;

      await this.$store
        .dispatch(POST_DATA, {
          listName: url
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            item.isApproved = true;

            item.approveDialog = false;

            this.createServiceRequest(item);
          } else {
            this.$snackbar.showMessage({
              content:
                response.data ||
                "Cannot approve proposal. Something went wrong!",
              color: "red"
            });
          }

          item.approveProcessing = false;
        });
    },

    async declineProposal(item) {
      item.declineProcessing = true;
      let url = `${API_CUSTOMERS}/${this.customerId}/proposals/${item.id}/decline`;

      await this.$store
        .dispatch(POST_DATA, {
          listName: url
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            item.isDeclined = true;
            item.declineDialog = false;
          } else {
            this.$snackbar.showMessage({
              content:
                response.data ||
                "Cannot approve proposal. Something went wrong!",
              color: "red"
            });
          }

          item.declineProcessing = false;
        });
    },

    async putProposalOnHold(item) {
      item.onHoldProcessing = true;
      let url = `${API_CUSTOMERS}/${this.customerId}/proposals/${item.id}/onHold`;

      await this.$store
        .dispatch(POST_DATA, {
          listName: url
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            item.isOnHold = true;
            item.onHoldDialog = false;
          } else {
            this.$snackbar.showMessage({
              content:
                response.data ||
                "Cannot approve proposal. Something went wrong!",
              color: "red"
            });
          }

          item.onHoldProcessing = false;
        });
    },

    createServiceRequest(item) {
      this.newRequest.communityId = this.customerId;
      this.newRequest.isOpen = true;
      this.newRequest.title =
        'Proposal "' + item.title + '" has just been approved.';

      let requestTypeObj = this.requestTypeItems[0];
      if (this.requestTypeItems.filter(el => el.name === "Other").length > 0)
        requestTypeObj = this.requestTypeItems.filter(
          el => el.name === "Other"
        )[0];

      this.newRequest.requestType = {
        id: requestTypeObj.id,
        name: requestTypeObj.name
      };

      let priorityObj = this.priorityItems[0];
      if (this.priorityItems.filter(el => el.name === "Normal").length > 0)
        priorityObj = this.priorityItems.filter(el => el.name === "Normal")[0];

      this.newRequest.priority = {
        id: priorityObj.id,
        name: priorityObj.name
      };

      this.newRequest.assignedTo = {
        id: this.communityInfo.accountManager.id
      };
      this.newRequest.targetCompletionDate = moment.utc(item.proposalDate);

      this.newRequest.attachments = [{ id: item.id, fileUrl: item.fileUrl }];

      this.serviceRequestProcessing = true;
      let self = this;
      this.$store
        .dispatch(POST_DATA, {
          listName: `${API_SERVICE_REQUESTS}`,
          data: this.newRequest
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            self.snackbarContent =
              "Service Request has been created successfully";

            self.$router.push({
              name: "CustomerRequests",
              params: { customerId: self.customerId }
            });
          } else {
            self.snackbarContent = response.data;
            self.snackbarColor = "red";
          }
          self.$snackbar.showMessage({
            content: self.snackbarContent,
            color: self.snackbarColor
          });
          self.serviceRequestProcessing = false;
        });
    },
    async getServiceStatus() {
      if (this.serviceStatusLoading) return;

      this.serviceStatusLoading = true;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: `${API_CUSTOMERS}/${this.customerId}/serviceStatus`
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.serviceStatus = response.data;
            if (!this.serviceStatus) {
              this.serviceStatus = {
                status: "On-Schedule",
                rescheduledDate: null,
                noServiceThisWeek: false
              };
            }
          }
          // else {
          // }
          this.serviceStatusLoading = false;
        });
    },
    getServiceStatusIconPath(serviceStatus) {
      switch (serviceStatus.status) {
        case "On-Schedule":
          //return "/media/assets/service-status/icons-on-schedule.png";
          return "/media/assets/icons/icons_service_on_schedule_orange.png";
        case "Rain-Out":
        case "Rain Out":
        case "Weather":
          return "/media/assets/icons/icons_service_rain_out_orange.png";
        case "Holiday":
          return "/media/assets/icons/icons_service_holiday_orange.png";
        case "Conflict":
          return "/media/assets/icons/icons_service_conflict_orange.png";
        default:
          return "/media/assets/icons/icons_service_conflict_orange.png";
      }
    },
    updateServiceStatus() {
      if (this.serviceStatusLoading) return;

      let statusStr = "";
      switch (this.serviceAlert.reason) {
        case 0:
          statusStr = "On-Schedule";
          break;
        case 1:
          statusStr = "Weather";
          break;
        case 2:
          statusStr = "Holiday";
          break;
        case 3:
          statusStr = "Conflict";
          break;
      }

      this.serviceAlert.noServiceThisWeek = false;
      let rescheduledDate = moment.utc();

      switch (this.serviceAlert.rescheduleDateItem) {
        case "Next business day":
          rescheduledDate = this.getBusinessDate(rescheduledDate, 1);
          break;
        case "2 business days later":
          rescheduledDate = this.getBusinessDate(rescheduledDate, 2);
          break;
        case "No service this week":
          rescheduledDate.add(1, "weeks");
          this.serviceAlert.noServiceThisWeek = true;
          break;
        case "Custom Date":
          rescheduledDate = moment.utc(this.alertDate);
          break;
        default:
          break;
      }

      const newStatus = {
        status: statusStr,
        rescheduledDate: rescheduledDate,
        // noServiceThisWeek: this.serviceAlert.noServiceThisWeek,
        updateAllCustomersInBranch:
          this.serviceAlert.target == "allCustomersInBranch",
        rescheduledText: this.serviceAlert.noServiceThisWeek
          ? "No service this week"
          : `Rescheduled ${this.formatDateUs(rescheduledDate)}`
      };
      this.communityInfo.serviceStatus = newStatus;

      this.serviceStatusLoading = true;

      this.$store
        .dispatch(POST_DATA, {
          listName: `${API_CUSTOMERS}/${this.customerId}/serviceStatus`,
          data: newStatus
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.serviceStatus = newStatus;
            this.$snackbar.showMessage({
              content: "Service Status has been updated"
            });
          }
          this.serviceStatusLoading = false;
        });

      this.serviceStatusDialog = false;
    },

    getBusinessDate(date, days) {
      let newDate = moment.utc(date).add(days, "days");
      if (newDate.isoWeekday() == 6) newDate.add(2, "days");
      if (newDate.isoWeekday() == 7) newDate.add(1, "days");
      return newDate;
    },
    sendMessage() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let newMessage = {
        isNew: true,
        // sendTo: [],
        subject: this.communityInfo.name + " rated 3.5 or less",
        body:
          this.communityInfo.name +
          " rated " +
          this.endValue +
          ". The reason: " +
          this.sentimentReason,
        attachments: [],
        isActionRequired: false,
        recipients: [{ id: this.communityInfo.accountManager.id }]
      };

      this.messageProcessing = true;

      let self = this;
      this.$store
        .dispatch(POST_DATA, {
          listName: `${API_MESSAGES}`,
          data: newMessage
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            self.snackbarContent = "Message has been sent";

            self.saveSentiment(self.endValue);
          } else {
            self.snackbarContent = response.data;
            self.snackbarColor = "red";
          }
          self.$snackbar.showMessage({
            content: self.snackbarContent,
            color: self.snackbarColor
          });

          self.messageProcessing = false;
          self.sentimentDialog = false;
        });
    },
    cancelSentimentChange() {
      this.sentimentDialog = false;
      this.communityInfo.sentiment.value = this.startValue;
    },
    saveSentiment(newValue) {
      this.$store
        .dispatch(POST_DATA, {
          listName: `${API_CUSTOMERS}/${this.communityInfo.id}/sentiment`,
          data: {
            value: newValue,
            modified: new Date()
          }
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.snackbarContent = "Sentiment has been updated successfully";
          } else {
            this.snackbarContent = response.data;
            this.snackbarColor = "red";
          }
          this.$snackbar.showMessage({
            content: this.snackbarContent,
            color: this.snackbarColor
          });

          this.confirmDialog = true;
        });
    },

    onSentimentChange(newValue) {
      this.endValue = newValue;
      this.sentimentDialog = newValue <= 3.5;

      if (!this.sentimentDialog) this.saveSentiment(newValue);
    },

    onStart(startValue) {
      this.startValue = startValue;
    },

    serviceStatusPromise() {
      return this.$store.dispatch(GET_QUERY, {
        listName: `${API_CUSTOMERS}/${this.communityInfo.aspireId}/serviceStatus`
      });
    },

    async getComunityInfo() {
      this.loading = true;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_CUSTOMERS,
          id: this.customerId
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            this.communityInfo = crud.getPopulatedComunityInfo(response.data);
            this.rating = Math.round(this.communityInfo?.sentiment?.value);
          } else {
            this.$snackbar.showMessage({
              content:
                response.data ||
                "Cannot receive Community details. Something went wrong!",
              color: "red"
            });
          }

          this.loading = false;
        });
    },
    reportPicture(report) {
      let defaultPicture =
        "https://cdn.vuetifyjs.com/images/parallax/material2.jpg";
      if (!report) return defaultPicture;

      if (report.photos.$values.length > 0) {
        let imagesToShow = report.photos.$values.filter(i => i.showInReport);
        if (imagesToShow && imagesToShow.length > 0)
          return imagesToShow[0].fileUrl;
        return report.photos.$values[0].fileUrl;
      }

      return defaultPicture;
    },

    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
    },
    formatDate(date) {
      return dateFormatter.formatEditDate(date);
    },
    formatDateUs(date) {
      // return moment(date).format("MM/DD/YYYY");
      return dateFormatter.formatDateUs(date);
    },
    capitalizeFirstLetter(string) {
      return stringFormatter.capitalizeFirstLetter(string);
    },
    formatUsMoney(value) {
      if (value)
        return "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return value;
    }
  },
  computed: {
    sentimentReasonErrors() {
      const errors = [];
      if (!this.$v.sentimentReason.$dirty) return errors;
      !this.$v.sentimentReason.required && errors.push("Required.");
      return errors;
    },
    accountManagerName() {
      return this.communityInfo?.accountManager?.fullName;
    },
    accountManagerEmail() {
      return this.communityInfo?.accountManager?.email;
    },
    accountManagerPhone() {
      return this.communityInfo?.accountManager?.phone;
    },
    propertyManagerName() {
      return this.communityInfo?.propertyManager?.fullName;
    },
    propertyManagerEmail() {
      return this.communityInfo?.propertyManager?.email;
    },
    propertyManagerPhone() {
      return this.communityInfo?.propertyManager?.phone;
    },
    communityInfoManagementCompanyName() {
      return this.communityInfo?.managementCompany?.name;
    },
    communityInfoManagementCompanyAddressLine1() {
      return this.communityInfo?.managementCompany?.address?.line1;
    },
    communityInfoManagementCompanyAddressCity() {
      return this.communityInfo?.managementCompany?.address?.city;
    },
    communityInfoManagementCompanyAddressStateCode() {
      return this.communityInfo?.managementCompany?.address?.stateCode;
    },
    communityInfoManagementCompanyAddressPostalCode() {
      return this.communityInfo?.managementCompany?.address?.postalCode;
    },
    communityInfoManagementCompanyAddressPhone() {
      return this.communityInfo?.managementCompany?.address?.phone;
    },
    // rating() {
    //   return this.communityInfo?.sentiment?.value;
    // },
    isOrangeReportsActive() {
      return this.activeSection === "orangeReports";
    },
    isProposalsActive() {
      return this.activeSection === "proposals";
    },
    isInvoicesActive() {
      return this.activeSection === "invoices";
    },
    isQuarterlyPlansActive() {
      return this.activeSection === "quarterlyPlans";
    },
    isWalkThroughsActive() {
      return this.activeSection === "walkThroughs";
    },
    fromErrors() {
      const errors = [];
      if (!this.$v.kudos.from.$dirty) return errors;
      !this.$v.kudos.from.required && errors.push("Required.");
      return errors;
    },
    bodyErrors() {
      const errors = [];
      if (!this.$v.kudos.body.$dirty) return errors;
      !this.$v.kudos.body.required && errors.push("Required.");
      return errors;
    },
    isValenciaResident() {
      return (
        (this.userInfo.profile.aspireRole == "Tenant/Resident - Neighborhood" ||
          this.userInfo.profile.aspireRole == "Tenant/Resident") &&
        this.customerId == 722266
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.page-specific-background {
  background-image: url("/media/assets/community-info-bg.jpg");
}
</style>
